import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

const getToken = () => {
  return localStorage.getItem("token");
};

export const AllTransferStationTransactions1 = async (
  StartDate,
  endDate,
  VehicleNumber,
  zoneId,
  circleId,
  collectionTypeId,
  ownerTypeId,
  vehicleTypeId,
  transferStationId
) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllTransferStationTransaction?startDate=${StartDate}&endDate=${endDate}&vehicleNumber=${VehicleNumber}&zoneId=${zoneId}&circleId=${circleId}&collectionTypeId=${collectionTypeId}&ownerTypeId=${ownerTypeId}&vehicleTypeId=${vehicleTypeId}&transferStationId=${transferStationId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};



export const AllTransferStationTransactions = async (
  StartDate, endDate, VehicleNumber, zoneId, circleId,
  collectionTypeId, ownerTypeId, VehicleTypeId, transferStationId
) => {
  const params = new URLSearchParams();
  params.set('startDate', StartDate);
  params.set('endDate', endDate);
  if (VehicleNumber)     params.set('VehicleNumber', VehicleNumber);
  if (zoneId)            params.set('ZoneId', zoneId);
  if (circleId)          params.set('CircleId', circleId);
  if (collectionTypeId)  params.set('CollectionTypeId', collectionTypeId);
  if (ownerTypeId)       params.set('OwnerTypeId', ownerTypeId);
  if (VehicleTypeId)     params.set('VehicleTypeIds', VehicleTypeId); // ← key: only sent when truthy
  if (transferStationId) params.set('TranferStationId', transferStationId);

  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL1}RawReport/GetAllTransferStationTransaction?${params.toString()}`,
      { headers: { Authorization: `Bearer ${getToken()}` } }
    );
    return response;
  } catch (error) {
    throw error;
  }
};


export const AllTransferStationTotalTransactions = async (
  StartDate,
  endDate,
  collectionTypeId,
  ownerTypeId,
  vehicleType,
  transferStationId
) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetAllTransferStationTransaction?startDate=${StartDate}&endDate=${endDate}&CollectionTypeId=${collectionTypeId}&OwnerTypeId=${ownerTypeId}&VehicleTypeId=${vehicleType}&TranferStationId=${transferStationId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const GetSCVTripsToTS = async (queryParams) => {
  const queryString = new URLSearchParams(queryParams).toString();
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `TransactionReport/GetTransferStationTripTransactionsDetails?CollectionTypeId=2&${queryString}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        },
    );
    return response;
  } catch (error) {
    throw error;
  }
};
